const getCleanType = (singleType: string) =>
  // remove optional indicator '?' at end and any spacing
  singleType.replace(/\?$/, '').trim();

export default getCleanType;
